module.exports = __webpack_public_path__ + "img/160.vacuum_cleaner.6bbdcb58.svg";